import React, { useState } from 'react'
import CreateAccount from './CreateAccount';
import PersonalInfo from './PersonalInfo';
import '../Styles/FastTrack.scss'
import GenerateRandomCode from '../Helper/GenerateRandomCode';
import { GroupPageOptions } from '../Constants/RegistrationPageOptions';
import { useNavigate } from "react-router-dom";
import CreateMedicalInsuranceInformation from './MedicalInsuranceInformation';
import Session from 'react-session-api';
import { Helmet } from "react-helmet";

// Retreats reach this step directly from week selection because they skip the Fast Track page, so
// Previous has to be told where to go back to rather than always assuming Fast Track came before it.
// Defaulting to the overnight camp's page keeps that flow working unchanged.
function ReservationSpotSelection({ numberOfSpots, setNumberOfSpots, setPaymentAmount, isFastTrack, fastTrack, setFastTrack, selectedPage, setSelectedPage, week,
   previousPage = GroupPageOptions.ReservationTypeSelection }) {

   const [validationError, setValidationError] = useState()
   // Deluxe rooms are full for these weeks. Remove a name when rooms reopen.
   const deluxeRoomsFullWeeks = ["Youth Week 3", "Junior Week 3", "Deaf Week 3"]
   const deluxeRoomsFull = deluxeRoomsFullWeeks.includes(week?.camp_name)
   console.log(week, "week in reservation spot selection");
   console.log("fast track", fastTrack)

   const SetReservationSpotsAndClearErrorMessage = (event) => {
      // Set Fast Track
      setNumberOfSpots(event.target.value)
      // Clear Error Alert
      setValidationError("");
   }

   const ValidateFastTrack = async (event) => {
      try {
         event.preventDefault()
         if (week.number_of_slots < numberOfSpots) {
            throw new Error("Please select a lower count. The current number of open slots is " + week.number_of_slots);
         }
         console.log("Options", fastTrack)
         if (isFastTrack && fastTrack.selectedOption === '') {
            throw new Error("Please select option 1 or 2")
         }
         // Option 2 may still be selected from another week chosen before going back
         if (isFastTrack && deluxeRoomsFull && fastTrack.selectedOption === "Option2") {
            throw new Error("Deluxe rooms are full for this week. Please select option 1.")
         }

         // Populate fast track 
         if (isFastTrack) {
            setPaymentAmount(100)
            fastTrack.fastTrackPromo1 = GenerateRandomCode.GenerateCode();
            (fastTrack.selectedOption === "Option1") ? fastTrack.fastTrackPromo2 = GenerateRandomCode.GenerateCode() : fastTrack.freeRoomOption = true
         }
         setSelectedPage(GroupPageOptions.Review)
      } catch (error) {
         setValidationError(error.message)
      }

   }

   function HandleRadioChange(event) {

   }

   function PrevPage(event) {
      event.preventDefault()
      setSelectedPage(previousPage)
   }

   return (
      <div>
         <div className="FastTrackContainer">
            <div className="FastTrackContent">
               <div className="FastTrackHeading">
                  {isFastTrack ? "Select Your Fast Track Reservation Options" : "Reserve Spots for Your Group"}
               </div>
               <div className="FastTrackOptions">
                  <form>
                     <div className="FastTrackNumberOfSlots">
                        <label>
                           Estimated Camper Count {" "}
                        </label>
                        <div className="FastTrackNumberOfSlotsInput">
                           <input
                              type="text"
                              required
                              value={numberOfSpots}
                              onChange={(event) => SetReservationSpotsAndClearErrorMessage(event)}
                           />
                        </div>
                     </div>
                     {validationError &&
                        <div className="FastTrackValidationError">{validationError}</div>
                     }
                     {isFastTrack && (
                        <>
                           <div className="FastTrackOption1">
                              <label>
                                 Option 1: Free Second Church Counselor{" "}
                              </label>
                              <div className="FastTrackOption1Input">
                                 <input
                                    type="radio"
                                    name="FastTrackOptions"
                                    required
                                    value={"Option1"}
                                    checked={fastTrack.selectedOption === "Option1"}
                                    onChange={(event) => setFastTrack({ ...fastTrack, selectedOption: (event.target.value) })}
                                 />
                              </div>
                           </div>
                           <div className="FastTrackOption2">

                              <label>
                                 Option 2: Free Deluxe Room
                              </label>
                              {deluxeRoomsFull
                                 ? <div style={{ margin: '10px', color: 'red' }}> Deluxe rooms reservations full for {week.camp_name}. Please select option 1 or email registration@billriceranch.org to join waiting list. </div>
                                 : <div className="FastTrackOption2Input">
                                    <input
                                       type="radio"
                                       name="FastTrackOptions"
                                       required
                                       value={"Option2"}
                                       checked={fastTrack.selectedOption === "Option2"}
                                       onChange={(event) => setFastTrack({ ...fastTrack, selectedOption: (event.target.value) })}
                                    />
                                 </div>
                              }
                           </div>
                        </>
                     )}
                  </form>
               </div>
               <div className="FastTrackButtonsContainer">
                  <div className="FastTrackPreviousButton">
                     <button onClick={PrevPage}>
                        Previous
                     </button>
                  </div>
                  <div className="FastTrackNextButton">
                     <button onClick={ValidateFastTrack}>
                        {isFastTrack ? "Add Fast Track" : "Continue"}
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>)
}
export default ReservationSpotSelection;